import { reactive } from 'vue'

export function createEventBus() {
  const state = reactive({})
  
  return {
    $on(event, callback) {
      if (!state[event]) {
        state[event] = []
      }
      state[event].push(callback)
    },
    
    $off(event, callback) {
      if (state[event]) {
        const index = state[event].indexOf(callback)
        if (index > -1) {
          state[event].splice(index, 1)
        }
      }
    },
    
    $emit(event, ...args) {
      if (state[event]) {
        state[event].forEach(callback => callback(...args))
      }
    }
  }
}
